/**
 * Main Class and namespace
 * @class Proj
 * @singletone
 */
var Proj = (function(proj) {
    "use strict";

    /** @type {String} session id */
    var sessionId = '';
    if (window.location.toString().match(/SESS_ID=(\d+)/)) {
        sessionId = RegExp.$1;
    }

    var _g = {};

    /**
     * Функция определения текущего интерфейса страницы
     */
    function getInterfaceName(){
        proj.interfaceName = _g.$body.data("interfaceName");
    }

    /* Адрес на который уходит ajax запрос */
    proj.AJAX_URI = '/json/';

    /* Метод запроса по умолчанию */
    proj.AJAX_METHOD = 'post';

    /* Таймаут запроса */
    proj.AJAX_TIMEOUT = 5000;

    /* ID сессии, на случай, если у пользователя отключены куки */
    proj.SESS_ID = sessionId;

    /* dataType ajax запроса по умолчанию */
    proj.AJAX_DATA_TYPE = 'json';


    proj.interfaceName = '';

    /* Параметры fancybox по умолчанию */
    proj.fancyBoxParams = {
            padding: 10,
            helpers: {
                title: { type: "inside" }
            }
        };

    /**
     * Функция инициализации окружения приложения
     */
    proj.init = function() {
        _g.$body = $(document.body);
        getInterfaceName();
    };

    /**
     * Обертка для ajax-запроса
     * @param  {Object} data      Хеш с данными. В хеше может быть указан ключ _do, который указывает какой метод вызвать.
     * @param  {Object} options   Хеш с дополнительными опциями. Может быть передано:
     *                                                            url - адрес, на которых нужно отправить запрос
     *                                                            _do - указание на то, какой метод вызвать
     *                                                            dataType - указание ожидаемого типа данных
     * Возвращает jqXHR объект jQuery, который является Promise объектом. Обработчики удачного ответа и неудачного ответа необходимо повесить на
     * стороне функции, которая вызывает запрос.
     */
    proj.getAJAX = function(data, options) {
        if (proj.SESS_ID) {
            data['SESS_ID'] = SESS_ID;
        }

        var url = proj.AJAX_URI;
        var timeout = proj.AJAX_TIMEOUT;
        var method = proj.AJAX_METHOD;
        var dataType = proj.AJAX_DATA_TYPE;

        if (options) {
            if (options.url) {
                url = options.url;
            }
            if (options.timeout) {
                timeout = options.timeout;
            }
            if (options.method) {
                method = options.method;
            }

            if (options.dataType) {
                dataType = options.dataType;
            }
        }
        if (data._do) {
            url = url + data._do + '/';
            delete data._do;
        } else {
            if ((options) && (options._do)) {
                url = url + options._do + '/'
            }
        }
            
        return $.ajax({
            type     : method,
            url      : url,
            data     : data,
            dataType : dataType,
            timeout  : timeout,
        });
    }

    return proj;

})(Proj || {});
